import { useState, useEffect } from "react";
import { API } from "@/App";

export function usePageContent(pageId) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/content/${pageId}`)
      .then((r) => r.json())
      .then((data) => {
        setContent(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [pageId]);

  // Helper: get field value by section id and field key
  const getField = (sectionId, fieldKey, fallback = "") => {
    if (!content?.sections) return fallback;
    const section = content.sections.find((s) => s.id === sectionId);
    if (!section) return fallback;
    const field = section.fields.find((f) => f.key === fieldKey);
    return field?.value || fallback;
  };

  return { content, loading, getField };
}
